export const QD_CLOUD_LOCAL_STORAGE_KEY = 'qodana-cloud-storage.v1.'

// use '.' only to distinct version
export const versionDelimiter = '.'

export enum StorageUnits {
	THEME = 'theme.v1.',
	CURRENT_ORGANIZATION_ID = 'current-organization-id.v1',
	PROMO_MODAL_VIEW_DATE = 'promo-modal-reset-date.v1',
	PRE_REDIRECT_URL_STATE = 'pre-redirect-url-state',
	USER_CONFIGURATION = 'user-configuration.v1.',
	RECENTLY_SEARCHED = 'organization/recently-searched',
	DEPRECATED_LINTER_VIEW_DATE = 'deprecated-linter-view-date.v1',
}
